import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Button } from 'ui-components/components/button';
import EditBatchNote from './edit-batch-note';
import style from './batch-note.module.less';

const BatchNote = ({ note, className = '', batchId, name, assignedToGuid, disabled = false }) => {
  const [showEditNoteInput, setShowEditNoteInput] = useState(false);

  const handleShowEditNoteInput = useCallback(() => {
    setShowEditNoteInput(!showEditNoteInput);
  }, [showEditNoteInput, setShowEditNoteInput]);

  return (
    <div className={classnames(style['batch-note-wrapper'], className)}>
      <div>
        <FormattedMessage defaultMessage='Batch Notes:' description='batchNote.batchNotes' id='P1iNHX' />
      </div>
      {showEditNoteInput && (
        <EditBatchNote
          assignedToGuid={assignedToGuid}
          batchId={batchId}
          handleShowEditNoteInput={handleShowEditNoteInput}
          name={name}
          note={note}
        />
      )}
      {!showEditNoteInput && (
        <div className={style['batch-note-label']}>
          <div>
            {!note || !note.length ? (
              <Button onClick={handleShowEditNoteInput} theme='link'>
                <FormattedMessage defaultMessage='Add a note' description='batchNote.addNote' id='1AIE9u' />
              </Button>
            ) : (
              <Button className={style.note} disabled={disabled} onClick={handleShowEditNoteInput} theme='unstyled'>
                <div className={style['note-content']}>{note && <div>{note}</div>}</div>
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

BatchNote.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  batchId: PropTypes.string,
  note: PropTypes.string,
  name: PropTypes.string,
  assignedToGuid: PropTypes.string,
};

export default BatchNote;
